import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import { motion } from "framer-motion"
import { Component, createRef } from "react"
import { css } from "styled-components"
import PathStep from "./PathStep"

const SPRING = { type: "spring", stiffness: 10, damping: 7 }
const STAGGER_S = 0.05

class PathStepsAnimator extends Component {
  contentRef = createRef()
  state = {
    measuredHeight: null
  }

  componentDidMount() {
    this.measureHeight()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Re-measure if steps changed
    if (nextProps.steps.length !== this.props.steps.length) {
      this.setState({ measuredHeight: null })
      this.measureHeight()
    }
  }

  measureHeight = () => {
    // Use double RAF to ensure DOM is fully laid out
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (this.contentRef.current) {
          const height = this.contentRef.current.scrollHeight
          if (height !== this.state.measuredHeight && height > 0) {
            this.setState({ measuredHeight: height })
          }
        }
      })
    })
  }

  render() {
    const { measuredHeight } = this.state
    const { expand, steps, getStepLinkProps, renderStepChevron } = this.props
    // Fallback to estimated height if not yet measured
    const targetHeight = measuredHeight ?? steps.length * 40

    return (
      <WithCSS
        as={motion.div}
        className="PathStepsAnimator"
        css={css`
          overflow: hidden;
          transform: translateZ(0);
          background-color: white;
          position: relative;
        `}
        initial={{ height: 0 }}
        animate={{ height: expand ? targetHeight : 0 }}
        transition={SPRING}
      >
        {/* Hidden measurement container - renders all steps to get accurate height */}
        <div
          ref={this.contentRef}
          style={{
            position: "absolute",
            visibility: "hidden",
            height: "auto",
            width: "100%",
            pointerEvents: "none"
          }}
        >
          {steps.map((step, index) => (
            <PathStep
              key={`measure-${index}`}
              className="PathStepsAnimator-measure-step"
              step={step}
              getStepLinkProps={getStepLinkProps}
            />
          ))}
        </div>
        {/* Visible animated steps */}
        {steps.map((step, index) => {
          const staggerDelay = expand
            ? index * STAGGER_S
            : (steps.length - 1 - index) * STAGGER_S
          return (
            <WithCSS
              key={index}
              as={motion.div}
              css={css`
                background-color: white;
                transform-origin: top center;
              `}
              initial={{ opacity: 0, scale: 0.7 }}
              animate={{
                opacity: expand ? 1 : 0,
                scale: expand ? 1 : 0.7
              }}
              transition={{ ...SPRING, delay: staggerDelay }}
            >
              <PathStep
                step={step}
                getStepLinkProps={getStepLinkProps}
                renderStepChevron={renderStepChevron}
              />
            </WithCSS>
          )
        })}
      </WithCSS>
    )
  }
}

PathStepsAnimator.displayName = "PathStepsAnimator"

export default PathStepsAnimator
